import { actionTypes } from '../actions/notification.action';

const init = [
    {
        'type': 'CALL',
        'url': '',
        'label': ''
    }
]
const initialState = {
    notifications: {
        data: []
    },
    notification: {
        buttons: init
    },
    error: {},
    success: false
}

const NotificationReducer = (state = initialState, { type, payload, isLoadMore }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.notifications.data = state.notifications.data.concat(payload.notifications.data)
        }

        return { ...state, ...payload }

    case actionTypes.CHANGE:
        return {
            ...state,
            notification: (payload === 'clear') ? { buttons: init } : {
                ...state.notification,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default NotificationReducer